
import { defineComponent } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { FormDataStructure } from '@/contracts/forms/FieldContracts'
import { NuxeoGetByEmailResponse } from '@/contracts/api/ResponseContracts'
import Heading from '@/components/Heading.vue'
import Form from '@/components/Form.vue'
import { nuxeoGetByEmail } from '@/composables/nuxeo'

export default defineComponent(
{
    name: 'Login',
    components:
    {
        Heading,
        Form
    },
    setup()
    {
        // Load router:
        const router = useRouter()
        const route = useRoute()
        // Load vuex:
        const store = useStore()

        // Set fields:
        const fields =
        {
            email:
            {
                name: 'email',
                type: 'Input',
                label: 'Email address',
                inputType: 'email',
                autocomplete: 'email',
                width: 'govuk-input--width-20',
                rules:
                {
                    required:
                    {
                        config: true
                    },
                    email:
                    {
                        config: true
                    },
                    max:
                    {
                        config: 255
                    }
                }
            }
        }
        // Set buttons:
        const buttons =
        {
            submit:
            {
                name: 'submit',
                type: 'Submit',
                text: 'Continue'
            }
        }
        // Handle submission:
        const saveFormData = (formData: FormDataStructure) =>
        {
            // Get user from email:
            nuxeoGetByEmail(
            {
                email: formData.email.toLowerCase()
            },
            function(response: NuxeoGetByEmailResponse)
            {
                store.commit('formData/setLoginData',
                {
                    email: formData.email.toLowerCase(),
                    id: response.id
                })
                if(route.params.redirect !== undefined)
                {
                    router.push({ name: 'LoginFinish', params: { back: 'Login', redirect: route.params.redirect as string } })
                }
                else
                {
                    router.push({ name: 'LoginFinish', params: { back: 'Login' } })
                }
            },
            [
                {
                    code: 404,
                    error: 'Failed to find user: email',
                    message: 'Email not found.',
                    field: 'email'
                }
            ])
        }

        // Return data:
        return {
            fields,
            buttons,
            saveFormData
        }
    }
})
